import { render, staticRenderFns } from "./canalcadenaformato.vue?vue&type=template&id=a77f3fee&scoped=true&"
import script from "./canalcadenaformato.vue?vue&type=script&lang=js&"
export * from "./canalcadenaformato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77f3fee",
  null
  
)

export default component.exports